<!-- <div class="position-sticky back-strip bg-white ">
    <div class="container py-3 font-secondary">
        <button class="btn btn-outline-dark rounded-pill py-2 px-3" (click)="back()"><img
                src="assets/icons/back_arrow_icon.svg" class="me-lg-2 white-icon" alt=""><span
                class="align-middle d-none d-lg-inline">BACK</span></button>
        <p class="d-inline-block ms-lg-4 mb-0 fs-5 page-heading text-center align-middle">Item Details</p>
    </div>
</div> -->
@if(instoreMode){
<app-operation-mode-header></app-operation-mode-header>
}
<div class="back-strip font-secondary bg-white firstDiv">
    <div class="container py-2 py-lg-3 d-flex" style="align-items: center;">
        <button class="btn btn-outline-dark rounded-pill py-2 px-3" (click)="back()"><img
                src="assets/icons/back_arrow_icon.svg" class="me-lg-2 white-icon" alt=""><span
                class="align-middle d-none d-lg-inline">BACK</span></button>
        <p class="d-inline-block ms-lg-5 mb-0 fs-5 page-heading text-center align-middle">Combo Details</p>
    </div>
</div>

<div class="container py-2 py-lg-4 item-detail-root-container">
    <div class="row pt-lg-1" [class.justify-content-center]="!(saleItemInfo?.itemComboOptionIds?.length > 0)">
        <div [class]="(saleItemInfo?.itemComboOptionIds?.length > 0) ? 'col-lg-5 text-center text-lg-start item-quantity' : 'col-lg-6 text-center item-quantity'">
            <div class="mb-4 pb-2 mb-lg-0 pb-lg-0">
                <img [src]="this.saleItemInfo.images !== null ? assetsUrl +((this.saleItemInfo.defaultImage !== null)? this.saleItemInfo.defaultImage:'/images/product/'+this.saleItemInfo.images[0]): 'assets/images/no-image-available.png'" width="390"
                    class="img-fluid mb-3 mb-lg-5 pb-lg-3 item-img" alt="">
                <h3 class="pb-1 pb-lg-0 mb-lg-4">{{this.saleItemInfo.name}}</h3>
                @if (saleItemInfo.description!==undefined && saleItemInfo.description.length>0) {
                <p class="mb-4 pb-2 dish-description">{{this.saleItemInfo.description}}</p>
                }
                <div class="d-flex align-items-center justify-content-center" [class.justify-content-lg-start]="saleItemInfo?.itemComboOptionIds?.length > 0">
                        <h3 class="mb-0 me-3 pe-1 font-secondary d-inline-block align-middle amount">
                            {{currencySymbol}}
                            {{(this.saleItemInfo.unitPriceWithTax+this.customizationUnitPriceWithTax)*this.selectedQuantity
                            | number:'1.2-2'}}</h3>
                    <mat-select [(ngModel)]="selectedQuantity" class="btn btn-outline-dark rounded-pill me-3"
                        style="width: 20%;" panelClass="rounded">
                        @for (qty of quantity; track $index) {
                        <mat-option [value]="qty.value">{{qty.label}}</mat-option>
                        }
                    </mat-select>
                    <!-- <a href="https://stpierres.co.nz/nutrition" target="_blank"
                        class="btn btn-outline-dark rounded-pill font-secondary py-2 px-4 text-truncate text-decoration-underline">
                        Nutrition Info</a> -->

                    @if (!(saleItemInfo?.itemComboOptionIds?.length > 0)) {
                    <div class="d-inline-block">
                        @if (!this.outOfStockItemIds.includes(saleItemInfo.id)) {
                        @if (this.isUpdating ==true) {
                        <button class="btn btn-primary rounded-pill font-secondary py-2 px-4" (click)="updateCart()" style="font-size: 18px;">
                            Update Order
                        </button>
                        }
                        @else {
                        <button class="btn btn-primary rounded-pill font-secondary py-2 px-4" (click)="addToCart()" style="font-size: 18px;">
                            Add to Order
                        </button>
                        }
                        }
                        @else {
                        <div class="bg-primary rounded-2 py-1 px-3 font-secondary text-danger text-center fs-4">
                            OUT OF STOCK
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
            <div>
                @if(this.promotions==true){
                @for (offer of offerList; track $index) {
                @if (offer.show_in_offers==1) {
                <div class="mt-3 mb-2 offer-description-desk" style="text-align: left;
                            color: red;
                        ">
                    {{offer.short_description}}
                </div>
                }
                }
                }
            </div>
        </div>

        @if (saleItemInfo?.itemComboOptionIds?.length > 0) {
        <div class="col-lg-7">
            <div class="mt-4 pt-2 mt-lg-0 pt-lg-0">
                <h3 class="font-secondary mb-2 pb-lg-1 mb-lg-3 text-center text-lg-start">Customise Your Combo</h3>
                @if (saleItemInfo.itemComboOptionIds!==undefined && saleItemInfo.itemComboOptionIds!==null &&
                saleItemInfo.itemComboOptionIds.length>0 ) {
                @for (comboOptionData of comboOptionDetails;track $index) {
                <mat-expansion-panel class="mat-elevation-z border mb-2 faq-indicator combo-panel" #customPanel
                    [expanded]="step === $index" (onOpen)="customizationAccordionOpen($index)"
                    (opened)="setStep($index)" [class]="customPanel.expanded?'pb-0':''">
                    <mat-expansion-panel-header class="my-1 bg-white px-3" [class]="!customPanel.expanded?'my-1':''">

                        <div class="title cust-option-title">

                            <span class="mb-0 fs-5 name" style="font-weight: 600;">{{comboOptionData.displayName}}</span>

                            @if (getCustomizationDisplayName(comboOptionData)!="") {

                            <span class="selected-cust-value">
                                ({{getCustomizationDisplayName(comboOptionData)}})
                            </span>
                            }
                            @else{
                                @for (custOptVal of comboOptionData.optionValue; track $index) {
                                    @if(custOptVal.isDefault==1){
                                        <span class="selected-cust-value">
                                            ({{custOptVal.name}})
                                        </span> 
                                    }
                                }
                            }
                        </div>

                    </mat-expansion-panel-header>
                    @for (custOptVal of comboOptionData.optionValue; track $index) {
                    @if (isValidCustOptVal(custOptVal)) {
                    @if (isOutOfStockCustOptVal(custOptVal)) {
                    <div class="item-container border px-2 py-2 d-inline-flex m-2" (click)="selectCustomization(custOptVal,comboOptionData)">
                        <div class="radio">
                            <div class="input-and-image-container">
                            <input class="form-check-input shadow-none" type="radio" name="{{comboOptionData.code}}"
                                id="no"
                                [checked]="custOptVal.isSelected===1">
                            <div class="justify-content-center" style="align-items: center;">
                                <img [src]="custOptVal.saleItem.images !== null ? imageUrl+((custOptVal.saleItem.defaultImage !== null)? custOptVal.saleItem.defaultImage:custOptVal.saleItem.images[0]): 'assets/images/no-image-available.png'"
                                 class="m-md-auto mb-md-4 item-image">
                            </div>
                        </div>
                            <div class="name-and-button-container">
                            <div class="form-check-label align-middle item-name-container" for="no">
                              <h5 class="item-name">{{custOptVal.name}}</h5> 
                            </div>
                            <div class="d-flex justify-content-between" style="width:100%;">
                            <div class="item-amount amount">
                                {{currencySymbol}}{{getOptionValueUnitPriceWithTax(custOptVal)|number:'1.2-2'}}
                            </div>
                            @if (custOptVal.saleItem.itemType==2) {
                            <div>
                                <button [disabled]="custOptVal.isSelected!==1"
                                [class.selected-button]="custOptVal.isSelected === 1"
                                    class="btn  rounded-pill py-0 px-1 py-sm-1 px-sm-2 font-secondary text-truncate  Customise-button " style="font-size:12px;" (click)="onCustomize(custOptVal)"><img
                                    [src]="custOptVal.isSelected === 1 ? 'assets/icons/chef_icon_white.svg' : 'assets/icons/chef_icon.svg'" width="14"
                                        class="me-sm-2 custom-icon white-icon" alt="">
                                    Customise
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                        </div>
                    </div>
                    }
                    @else {
                    <div class="item-container border px-2 py-2 d-inline-flex m-2">
                        <div class="radio">
                            <input class="form-check-input shadow-none" type="radio" name="flexRadioDefault" id="no"
                                (click)="selectCustomization(custOptVal,comboOptionData)">
                            <div class="justify-content-center" style="align-items: center;">
                                <img [src]="custOptVal.saleItem.images !== null ? imageUrl+((custOptVal.saleItem.defaultImage !== null)? custOptVal.defaultImage:custOptVal.saleItem.images[0]): 'assets/images/no-image-available.png'"
                                    style="object-fit: contain;height: 80px; display: block;
                                    margin-left: auto;
                                    margin-right: auto;" class="m-md-auto mb-md-4">
                            </div>
                            <div class="form-check-label align-middle" for="no" style="overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;width: 100px;">
                                {{custOptVal.name}}
                            </div>
                            
                            <div>
                                @if (custOptVal.isDefault==1) {
                                ({{currencySymbol}}{{custOptVal.price|number:'1.2-2'}})
                                }
                                @else {
                                ({{currencySymbol}}{{custOptVal.price|number:'1.2-2'}})
                                }
                            </div>
                            @if (custOptVal.saleItem.itemType==2) {
                            <div>
                                <button
                                    class="btn btn-outline-dark rounded-pill py-1 px-2 py-sm-2 px-sm-3 font-secondary text-truncate" (click)="onCustomize(custOptVal)"><img
                                        src="assets/icons/chef_icon.svg" width="24"
                                        class="me-sm-2 custom-icon white-icon" alt="">
                                    Customise
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    }

                    }
                    }
                </mat-expansion-panel>
                }
                }
                <!-- <div class="mb-4">
                    <label for="message" class="form-label mb-3 fs-5 mt-3 pt-1">Special Instructions</label>
                    <textarea class="form-control shadow-none rounded-1 p-3" style="resize: none;" id="message" rows="5"
                        (keydown.enter)="onKeydown($event)"
                        placeholder="Add notes on your allergies. Requests that cost extra will not be fulfilled."
                        [(ngModel)]="this.remark"></textarea>
                </div> -->
                <div class="cart-update-anim">
                    <div class="cart-update-msg">
                      CART UPDATED
                    </div>
                  </div>
                @if (!this.outOfStockItemIds.includes(saleItemInfo.id)) {
                @if (this.isUpdating ==true) {
                <button class="btn btn-primary rounded-pill font-secondary py-2 px-4 mb-5" (click)="updateCart()" style="font-size: 18px;">
                    Update Order
                </button>
                }
                @else {
                <button class="btn btn-primary rounded-pill font-secondary py-2 px-4 mb-5" (click)="addToCart()" style="font-size: 18px;">
                    Add to Order
                </button>
                }
                }
                @else {
                <div class="bg-primary rounded-2 py-1 px-2 py-sm-1 px-sm-3 font-secondary text-danger text-center fs-4">
                    OUT OF STOCK
                </div>
                }
            </div>
        </div>
        }
    </div>
</div>